import { useTranslation } from "react-i18next";
import { Link, useLocation } from "react-router-dom";
import { SidebarRoute } from "../../utils/routes/types";

interface IProps {
  routes: SidebarRoute[] | undefined;
}

const SidebarItems = ({ routes }: IProps) => {
  const { pathname } = useLocation();
  const { t } = useTranslation();
  return (
    <ul className="main-menu" style={{ marginLeft: 0, marginRight: 0 }}>
      {routes?.map(({ path, sidebar }) => {
        const isActive = pathname.includes(path);
        return (
          <li className={"slide"} key={path}>
            <Link
              to={path}
              className={`${isActive ? "active" : ""} d-flex align-items-center side-menu__item `}
            >
              {sidebar.icon(isActive ? "#fff" : "var(--menu-prime-color)")}
              <span className="side-menu__label ms-2">
                {t(`sidebar.${sidebar.title}`)}
              </span>
            </Link>
          </li>
        );
      })}
    </ul>
  );
};

export default SidebarItems;
